export const errorMessages = [
  { statusCode: 0, errorMessage: 'The question is not trained yet, Please contact trainer' },
    { statusCode: 202, errorMessage: 'There is no data to show. Please check back later...' },
    { statusCode: 400, errorMessage: 'Bad Request: The server could not understand the request.' },
    { statusCode: 401, errorMessage: 'Unauthorized: Authentication required.' },
    { statusCode: 403, errorMessage: 'Forbidden: You do not have permission to access this resource.' },
    { statusCode: 404, errorMessage: 'Not Found: The requested resource could not be found.' },
    { statusCode: 500, errorMessage: 'The provided question is unclear and does not specify what information is needed. Please provide a clear question or request for assistance.' },
    { statusCode: 503, errorMessage: 'Service Unavailable: The server is temporarily unable to handle the request.' },
  ];
  